import { render } from "./EmployeeSecurity.vue?vue&type=template&id=6bbce846&scoped=true"
import script from "./EmployeeSecurity.vue?vue&type=script&lang=js"
export * from "./EmployeeSecurity.vue?vue&type=script&lang=js"

import "./EmployeeSecurity.vue?vue&type=style&index=0&id=6bbce846&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbce846"]])

export default __exports__